// Predefined responses for common questions
const responses = {
  greeting: [
    "Hallo! Ich bin Benedikt Stein, Ihr persönlicher Berater für Outplacement-Services. Wie kann ich Ihnen heute helfen?",
    "Hi! Welcome to Recruta. I'm Benedikt Stein, your personal outplacement advisor. How can I assist you today?"
  ],
  services: [
    "Unsere Hauptdienstleistungen umfassen:\n- Karriere-Coaching\n- Jobvermittlung\n- Kompetenzentwicklung\n- Unterstützungsprogramme",
    "Our main services include:\n- Career coaching\n- Job placement\n- Skills development\n- Support programs"
  ],
  pricing: [
    "Wir bieten drei Hauptpakete an:\n- Basic: 2.000€ pro Mitarbeiter\n- Premium: 4.000€ pro Mitarbeiter\n- Executive: 10.000€ pro Mitarbeiter\nKontaktieren Sie uns für individuelle Angebote!",
    "We offer three main packages:\n- Basic: €2,000 per employee\n- Premium: €4,000 per employee\n- Executive: €10,000 per employee\nContact us for custom solutions!"
  ],
  process: [
    "Unser Prozess besteht aus vier Hauptschritten:\n1. Bewertung der aktuellen Situation\n2. Entwicklung einer personalisierten Strategie\n3. Durchführung von Schulungen und Coaching\n4. Aktive Jobsuche und Vermittlung",
    "Our process consists of four main steps:\n1. Assessment of current situation\n2. Development of personalized strategy\n3. Training and coaching execution\n4. Active job search and placement"
  ],
  benefits: [
    "Die Vorteile unserer Outplacement-Services:\n- Schnelle Wiedereingliederung\n- Professionelle Betreuung\n- Kosteneffizienz\n- Schutz der Arbeitgebermarke\n- Rechtssicherheit",
    "The benefits of our outplacement services:\n- Quick reintegration\n- Professional support\n- Cost efficiency\n- Employer brand protection\n- Legal security"
  ],
  success: [
    "Unsere Erfolgsgeschichten zeigen:\n- 90% Vermittlungsquote\n- Durchschnittlich 8 Wochen bis zur Neuanstellung\n- 95% Zufriedenheit bei Kunden und Mitarbeitern",
    "Our success stories show:\n- 90% placement rate\n- Average of 8 weeks until new employment\n- 95% satisfaction among clients and employees"
  ]
};

export const generateResponse = async (input: string): Promise<string> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));

  const lowercaseInput = input.toLowerCase();

  // Check for greetings
  if (lowercaseInput.includes('hi') || lowercaseInput.includes('hello') || lowercaseInput.includes('hallo')) {
    return responses.greeting[0];
  }

  // Check for service inquiries
  if (lowercaseInput.includes('service') || lowercaseInput.includes('dienstleistung') || lowercaseInput.includes('angebot')) {
    return responses.services[0];
  }

  // Check for pricing inquiries
  if (lowercaseInput.includes('price') || lowercaseInput.includes('cost') || lowercaseInput.includes('preis') || lowercaseInput.includes('kosten')) {
    return responses.pricing[0];
  }

  // Check for process inquiries
  if (lowercaseInput.includes('process') || lowercaseInput.includes('how') || lowercaseInput.includes('prozess') || lowercaseInput.includes('wie')) {
    return responses.process[0];
  }

  // Check for benefits inquiries
  if (lowercaseInput.includes('benefit') || lowercaseInput.includes('vorteil') || lowercaseInput.includes('nutzen')) {
    return responses.benefits[0];
  }

  // Check for success stories
  if (lowercaseInput.includes('success') || lowercaseInput.includes('erfolg') || lowercaseInput.includes('reference')) {
    return responses.success[0];
  }

  // Default response
  return "Ich verstehe Ihre Frage. Lassen Sie uns einen Termin vereinbaren, damit ich Ihnen detailliert helfen kann. Sie können entweder den Kalender-Button nutzen oder mir Ihre Kontaktdaten hier mitteilen.";
};